import { apiClient } from "../client";
const ENDPOINTS = {
    LOGIN: "/account/login",
    VERIFY_OTP: "/account/otp",
    RESEND_EMAIL: "/account/resend-email",
    ME: "/account/me",
    REFRESH_TOKEN: "/account/refresh-token",
};
export const authService = {
    login: (data) => apiClient.post(ENDPOINTS.LOGIN, data),
    verifyOtp: (data) => apiClient.post(ENDPOINTS.VERIFY_OTP, data),
    resendEmail: (email) => apiClient.post(ENDPOINTS.RESEND_EMAIL, { email }),
    getCurrentUser: () => apiClient.get(ENDPOINTS.ME),
    refreshToken: () => apiClient.post(ENDPOINTS.REFRESH_TOKEN),
};
